import compuedFun from '../computed/'
const computedData = compuedFun()

export const searchForm = {
  slug: '', // 标识
  line_id: undefined, // 发布平台
  state: undefined, // 状态
  class: undefined, // 类型
  platform_class: undefined, // 平台分类
  // picture_type: undefined, // app平台
  start_time: '',
  end_time: ''
}

export const columns = [
  {
    title: 'ID',
    align: 'center',
    width: 60,
    dataIndex: 'id'
  },
  {
    title: '发布平台',
    align: 'left',
    width: 220,
    dataIndex: 'org',
    // scopedSlots: { customRender: 'org' }
  },
  {
    title: '平台分类',
    dataIndex: 'platform_class',
    align: 'center',
    width: 100,
    customRender(text) {
      return computedData.showName('PICTURES_PLATFORM_CLASS', text)
    }
  },
  {
    title: '类型',
    align: 'left',
    width: 130,
    dataIndex: 'class',
    scopedSlots: { customRender: 'class' },
    customRender(text) {
      return computedData.showName('PICTURES_CLASS_TYPE', text)
    }
  },
  {
    // title: '标识',
    width: 130,
    dataIndex: 'slug',
    slots: { title: "slug" },
    key: 'slug',
  },
  {
    title: '图片',
    align: 'left',
    width: 160,
    dataIndex: 'path',
    scopedSlots: { customRender: 'path' }
  },
  {
    title: '跳转地址',
    dataIndex: 'link_url',
    align: 'left',
    width: 110,
    scopedSlots: { customRender: 'link_url' }
  },
  {
    title: '排序',
    dataIndex: 'sort',
    align: 'left',
    width: 60,
    scopedSlots: { customRender: 'sort' }
  },
  {
    title: '示例',
    align: 'left',
    width: 90,
    dataIndex: 'demo_picture',
    scopedSlots: { customRender: 'demo_picture' }
  },
  {
    title: '示例说明',
    align: 'left',
    width: 110,
    dataIndex: 'literal_explan',
    scopedSlots: { customRender: 'literal_explan' }
  },
  {
    title: '状态',
    dataIndex: 'state',
    align: 'left',
    width: 100,
    scopedSlots: { customRender: 'state' }
  },
  {
    title: '起止时间',
    dataIndex: 'start_end_times',
    align: 'left',
    width: 200,
    scopedSlots: { customRender: 'start_end_times' }
  },
  {
    title: '操作',
    dataIndex: 'operation',
    fixed: 'right',
    align: 'left',
    width: 100,
    scopedSlots: { customRender: 'operation' }
  }
]
